import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id 890D584F-45C1-4D2C-96C0-373465DB6477
 * name step-forward-2
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/step-forward-2.svg
 * tags
 */
export const StepForward2Icon = createSvgIcon(<><path d="M7,5H10V19H7V5M12,5L23,12L12,19V5M2,5H5V19H2V5Z" /></>, 'StepForward2Icon');
export default StepForward2Icon